import { createI18n } from 'vue-i18n'
import { usePerfStepManual } from 'hooks/usePerfStep.js'
import { useUserAuthStore } from 'src/stores/user/auth'
import { defaultLang, getLocale } from 'src/common/functions'
import { setStoredLocale } from 'src/common/utils/locale'
import { getConsumerLocale, shouldPersistI18nLocale } from 'src/core/locale/runtime'
import { createLocaleLoader } from './i18n-loader'
import { getConfig } from '@/configs/index.js'

let i18nObject = null

export default ({ app }) => {
  const config = getConfig()
  const authStore = useUserAuthStore()
  const locale = getConsumerLocale({
    consumer: 'i18n',
    profileLocale: authStore.getUserLanguage,
    getFallbackLocale: getLocale,
  })

  if (shouldPersistI18nLocale()) {
    setStoredLocale(locale)
  }

  const spanI18n = usePerfStepManual('boot.i18n')

  const fallbackMap = config.fallbackLangMap

  i18nObject = createI18n({
    legacy: false,
    locale,
    globalInjection: true,
    fallbackLocale: fallbackMap,
    messages: {},
    pluralRules: {
      ru: function (choice, choicesLength) {
        if (choice === 0) {
          return 0
        }

        const teen = choice > 10 && choice < 20
        const endsWithOne = choice % 10 === 1

        if (choicesLength < 4) {
          return !teen && endsWithOne ? 1 : 2
        }
        if (!teen && endsWithOne) {
          return 1
        }
        if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
          return 2
        }

        return choicesLength < 4 ? 2 : 3
      },
    },
  })

  app.use(i18nObject)

  const { loadLanguage } = createLocaleLoader({
    loadMessages: (locale) => import(`../i18n/${locale}.json`),
    setLocaleMessage: (locale, messages) => i18nObject.global.setLocaleMessage(locale, messages),
    setLocale: (locale) => {
      i18nObject.global.locale.value = locale
    },
    defaultLocale: defaultLang,
    fallbackMap,
  })

  return loadLanguage(locale).finally(() => {
    spanI18n.finish()
  })
}

export { i18nObject }
